/* tslint:disable:rule1 max-line-length */

import classnames from 'classnames';
import * as React from 'react';

export const EditIcon = ({ onClick }: { onClick?: () => void }) => {
  return (
    <svg
      width='26px'
      height='26px'
      viewBox='0 0 26 26'
      version='1.1'
      onClick={onClick}
      className={classnames('edit-menu-icon')}
    >
      <desc>Created with sketchtool.</desc>
      <g id='User-Roles' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd' opacity='0.5'>
        <g id='Member-List' transform='translate(-1161.000000, -176.000000)' fill='#FAFAFF' stroke='#3023AE'>
          <g id='Group-9' transform='translate(1105.000000, 177.000000)'>
            <g id='Page-1-Copy-4' transform='translate(57.000000, 0.000000)'>
              <path
                d='M17.176743,3.2069189 L20.7869319,6.83922053 L5.10061554,22.5212022 L0.804947761,23.1951773 L1.47909341,18.9005965 L17.176743,3.2069189 Z M19.5073713,0.876880367 L23.1175602,4.509182 L21.3126485,6.31363694 L17.6794276,2.70436157 L19.5073713,0.876880367 Z M19.4159741,0.00882679697 C19.3501681,0.0263706165 19.2909427,0.062189248 19.244513,0.11153124 L0.885011696,18.4663869 C0.831635739,18.5190184 0.795808042,18.5866352 0.782281258,18.6604654 L0.00540517105,23.5720039 C-0.0289601712,23.7708339 0.104114133,23.9597954 0.302994411,23.9945176 C0.344305939,24.0018275 0.386714234,24.0018275 0.428025762,23.9945176 L5.34080734,23.217838 C5.41429068,23.2043147 5.48229019,23.1681306 5.53493497,23.1151336 L23.8944362,4.76027792 C24.0351879,4.61773439 24.0351879,4.38856824 23.8944362,4.24602471 L19.7585308,0.11153124 C19.6700583,0.0197916842 19.5402743,-0.0189509173 19.4159741,0.00882679697 Z'
                id='Fill-1'
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
